import { useQuery } from '@tanstack/react-query';
import { SettlementEvent, ReplayVerification } from '@solante/shared';
import { http } from './http';

interface ResultResponse {
  settlement: SettlementEvent;
  replay: ReplayVerification;
  explorers: {
    settlementUrl: string;
    matchAccountUrl: string;
  };
}

export const useMatchResult = (matchId?: string) =>
  useQuery({
    queryKey: ['match', matchId, 'result'],
    enabled: Boolean(matchId),
    queryFn: () => http.get<ResultResponse>(`/matches/${matchId}/result`),
  });
